import { cloneDeep } from 'lodash';

const _ = { cloneDeep };

const initialState = {
    isLoading: false,
    matchList: [],
    matches: {},
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'ALL_MATCHES:FETCH_REQUEST':
            return {
                ...state,
                isLoading: true,
            };
        case 'ALL_MATCHES:FETCH_REQUEST_SUCCESS':
            return {
                ...state,
                matchList: action.data,
                isLoading: false,
            };
        case 'ALL_MATCHES:FETCH_REQUEST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'ALL_MATCHES:FETCH_MATCH_DETAILS_REQUEST':
            return {
                ...state,
                isLoading: true,
            };
        case 'ALL_MATCHES:FETCH_MATCH_DETAILS_REQUEST_SUCCESS': {
            const matches2 = _.cloneDeep(state.matches);
            const { player1Id, player2Id } = action.data;
            const matchIndex = `${player1Id.toString()}-${player2Id.toString()}`;
            matches2[matchIndex] = action.data.data;
            return {
                ...state,
                isLoading: false,
                matches: matches2,
            };
        }
        case 'ALL_MATCHES:FETCH_MATCH_DETAILS_REQUEST_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}

export default app;
